/* eslint-disable */
export default {
  logging: 'Registrando...',
  logCall: 'Registrar chamada',
  editLog: 'Editar log',
  select: 'Selecionar um registro correspondente',
  OnHold: 'Em espera',
  Ringing: 'Chamando',
  CallConnected: 'Chamada conectada',
  unknownUser: 'Usuário desconhecido',
  unknownNumber: 'Anônimo',
  unavailable: 'Indisponível',
  viewDetails: 'Exibir detalhes',
  addEntity: 'Criar novo',
  addLog: 'Log',
  text: 'Texto',
  call: 'Chamada',
  missedCall: 'Perdida',
  inboundCall: 'Entrada',
  outboundCall: 'Saída',
  answeredBy: 'Atendida por',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
